<template>
  <el-carousel :autoplay="false" :interval="5000" arrow="always" indicator-position="none">
    <el-carousel-item v-for="(group, index) in iconGroups" :key="index">
      <div class="icon-box">
        <div class="icon-group">
          <div v-for="(icon, i) in group" :key="i" class="icon-item" style="border: 1rpx solid black;">
            <div class="icon-img">
              <img :src="icon.img" alt="icon" />
            </div>
            <div class="icon-title">{{ icon.title }}</div>
          </div>
        </div>
      </div>

    </el-carousel-item>
  </el-carousel>
</template>


<script>
  export default {
    name: "IconCarousel",
    data() {
      return {
        // 12个图标分成3组，每组4个图标
        iconGroups: [
          [{
              img: require('@/assets/image/index/syfw.png'),
              title: '商业服务'
            },
            {
              img: require('@/assets/image/index/txfw.png'),
              title: '通信服务'
            },
            {
              img: require('@/assets/image/index/jzfw.png'),
              title: '建筑工程'
            },
            {
              img: require('@/assets/image/index/jyfw.png'),
              title: '教育服务'
            },
          ],
          [{
              img: require('@/assets/image/index/fxfw.png'),
              title: '分销服务'
            },
            {
              img: require('@/assets/image/index/hjfw.png'),
              title: '环境服务'
            },
            {
              img: require('@/assets/image/index/jrfw.png'),
              title: '金融服务'
            },
            {
              img: require('@/assets/image/index/jkjshfu.png'),
              title: '健康及社会服务'
            },
          ],
          [{
              img: require('@/assets/image/index/lyfw.png'),
              title: '旅游服务'
            },
            {
              img: require('@/assets/image/index/wyty.png'),
              title: '文化娱乐体育'
            },
            {
              img: require('@/assets/image/index/ysfw.png'),
              title: '运输服务'
            },
            {
              img: require('@/assets/image/index/qtfw.png'),
              title: '其他服务'
            },
          ]
        ],

      };
    },
    methods: {

    }
  };
</script>

<style scoped>
  .el-carousel__item {
    background-color: #EFF8F5;
  }

  .icon-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }


  .icon-group {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 80%;
    height: 100%;
  }

  .icon-item {
    margin: auto;
    text-align: center;
  }

  .icon-img {
    width: 5vw;
    height: 5vw;
    border-radius: 50%;
    overflow: hidden;
    /* border: 1px solid red; */
    margin-bottom: 1vw;
    /* margin-bottom: 10px; */
  }

  .icon-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    /* border: 1px solid red; */
  }

  .icon-title {
    font-size: 1.1vw;
    color: #009173;
    /* border: 1px solid red; */
  }


  /* 移动端适配 */
  @media (max-width: 768px) {
    .icon-group {
      width: 100%;
      justify-content: space-between;
      display: flex;
      flex-wrap: wrap;
      /* 允许子元素换行 */
      justify-content: flex-start;
      /* 左对齐 */
      gap: 1vw;
      /* 可选：设置元素间距 */
      /* padding: 0 15px; */
    }

    .icon-item {
      /* 设置每个图标的固定宽度或最小宽度 */
      min-width: 100px;
      /* 根据实际需求调整 */
      /* 或者使用固定宽度：width: 80px; */
      display: flex;
      flex-direction: column;
      align-items: center;
      /* padding: 5px; */
      box-sizing: border-box;
    }

    .icon-img {
     width: 20vw;
      height: 20vw;
      max-width: 80px;
      max-height: 80px;
    }

    .icon-title {
      font-size: 15px;
    }

    /* 调整箭头大小 */
    ::v-deep .el-carousel__arrow {
      width: 30px;
      height: 30px;
      font-size: 14px;
    }
  }

</style>
